import { DollarSign } from "lucide-react";

/** Tarjeta de KPI de ingresos (día/semana/mes/año), siempre anclada al
 * momento actual sin importar el selector de periodo elegido. */
export default function KpiCard({ label, amount, range, testId }) {
  return (
    <div className="bg-white border border-border rounded-xl p-5 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200" data-testid={testId}>
      <div className="w-9 h-9 rounded-lg bg-brand-light flex items-center justify-center mb-3">
        <DollarSign className="w-4.5 h-4.5 text-brand" />
      </div>
      <p className="font-serif text-2xl sm:text-3xl text-foreground">${amount.toFixed(2)}</p>
      <p className="text-sm text-muted-foreground mt-1">{label}</p>
      {range && <p className="text-xs text-muted-foreground/70 mt-0.5" data-testid={`${testId}-range`}>{range}</p>}
    </div>
  );
}
